import { setCookie } from "app/utils/cookie";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

export const captureUTMParams = (): void => {
  const searchParams = new URLSearchParams(window.location.search);

  UTM_KEYS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) {
      setCookie(key, value, 3650);
    }
  });

  const returnUrl = searchParams.get("return_url");
  if (returnUrl?.includes("?")) {
    const returnParams = new URLSearchParams(returnUrl.split("?")[1]);
    UTM_KEYS.forEach((key) => {
      const value = returnParams.get(key);
      if (value) {
        setCookie(key, value, 3650);
      }
    });
  }
};
